import { c as _c } from "react-compiler-runtime";
import { useCallback, useMemo } from 'react';
import { useTracker } from 'framework-listing-lib/internal/providers/TrackerProvider';
import useUIMode from 'framework-listing-lib/internal/hooks/useUIMode';
import listingLibPerformanceTracking from 'framework-listing-lib/internal/utils/performanceTracking';
import useObjectTypeId from 'framework-listing-lib/internal/hooks/useObjectTypeId';
export default function useCrmObjectTypeTracking() {
  "use memo";

  const $ = _c(19);
  const objectType = useObjectTypeId();
  const uiModeProps = useUIMode();
  const {
    applicationId,
    track,
    onTrackEvent
  } = useTracker();
  let t0;
  if ($[0] !== applicationId || $[1] !== objectType || $[2] !== onTrackEvent || $[3] !== track || $[4] !== uiModeProps.currentUIMode) {
    t0 = eventProps => {
      if (onTrackEvent) {
        onTrackEvent(eventProps.action, eventProps);
      }
      track === null || track === void 0 || track("Crm Table", "Crm Table Interaction", Object.assign({
        applicationId,
        objectType,
        uiMode: uiModeProps.currentUIMode
      }, eventProps));
    };
    $[0] = applicationId;
    $[1] = objectType;
    $[2] = onTrackEvent;
    $[3] = track;
    $[4] = uiModeProps.currentUIMode;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const trackCrmTableInteraction = t0;
  let t1;
  if ($[6] !== applicationId || $[7] !== objectType || $[8] !== onTrackEvent || $[9] !== track) {
    t1 = eventProps_0 => {
      if (onTrackEvent) {
        onTrackEvent(eventProps_0.action, eventProps_0);
      }
      track === null || track === void 0 || track("Filter Editor", "Filter Editor Interaction", Object.assign({
        applicationId,
        objectType
      }, eventProps_0));
    };
    $[6] = applicationId;
    $[7] = objectType;
    $[8] = onTrackEvent;
    $[9] = track;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  const trackFilterEditorInteraction = t1;
  let t2;
  if ($[11] !== applicationId || $[12] !== objectType || $[13] !== track) {
    t2 = () => {
      listingLibPerformanceTracking.trackLibPerformance({
        applicationId,
        objectTypeId: objectType,
        track
      });
    };
    $[11] = applicationId;
    $[12] = objectType;
    $[13] = track;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  const trackPerformanceInteraction = t2;
  let t3;
  if ($[15] !== trackCrmTableInteraction || $[16] !== trackFilterEditorInteraction || $[17] !== trackPerformanceInteraction) {
    t3 = {
      trackCrmTableInteraction,
      trackFilterEditorInteraction,
      trackPerformanceInteraction
    };
    $[15] = trackCrmTableInteraction;
    $[16] = trackFilterEditorInteraction;
    $[17] = trackPerformanceInteraction;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  const value = t3;
  return value;
}